import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 查看答题记录
  function handleInfo(item) {
    vue.$emit("previewInvesResult", item);
  }

  //操作列按钮
  const Deal = ({ props: { vo } }) => {
    let butn;
    if (vo.row.isJoin === 1) {
      butn = ["答题记录", () => handleInfo(vo.row), "icon-deal", ""];
    } else {
      butn = ["--", "", "", ""];
    }
    const dealConf = [butn];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            v-permission={item[3]}
            placement="top"
          >
            <i class={item[2]} onClick={item[1]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150"
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150"
    },
    {
      label: "已完成调查",
      prop: "isJoinName",
      minWidth: "100"
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
